import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';

/** Lets a page replace the label of its own crumb (e.g. show the GEM ID instead of a UUID). */
const Ctx = createContext<{ label: string | null; setLabel: (l: string | null) => void }>({ label: null, setLabel: () => {} });

export function BreadcrumbProvider({ children }: { children: ReactNode }) {
  const [label, setLabel] = useState<string | null>(null);
  return <Ctx.Provider value={{ label, setLabel }}>{children}</Ctx.Provider>;
}

export function useBreadcrumbLabel() {
  return useContext(Ctx).label;
}

export function useSetBreadcrumb(label: string | null | undefined) {
  const { setLabel } = useContext(Ctx);
  useEffect(() => {
    setLabel(label ?? null);
    return () => setLabel(null);
  }, [label, setLabel]);
}
